<template>
    <div class="check-vin-bar">
        <div class="vin-bar-main">
            <div class="left">
                <div class="title">Ready to check your vehicle?</div>
                <div class="tip">Enter a VIN and get a free preview instantly  no account needed.</div>
                <div class="tip">Full report available in minutes.</div>
            </div>
            <div class="right">
                <vin-input type="dark"></vin-input>
            </div>
        </div>
    </div>
</template>
<script>
import VinInput from './VinInput.vue';
export default {
    name: 'CheckVinBar',
    components: {
        VinInput
    }
}
</script>
<style lang="scss" scoped>
.check-vin-bar {
    font-family: "Alibaba PuHuiTi 3.0";
    background: linear-gradient(94deg, #103ea0cc 0%, #196ee6cc 100%), linear-gradient(94deg, #103ea0 0%, #6700de 71%, #1934e6 100%);
    .vin-bar-main {
        width: 1600px;
        margin: 0 auto;
        padding: 26px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
            .title {
                font-size: 30px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;
                height: 42px;
                color: #FFFFFF;
                margin-bottom: 10px;
            }
            .tip {
                font-size: 16px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;
                color: #FFFFFF;
            }
        }
        .right {
            width: 600px;
        }
    }
}
</style>